import {replaceExrtaSpaces} from '@/utils/commons';
import React from 'react';
import PropTypes from 'prop-types';

export const ReviewHtmlRow = ({label, value}) => (
  <div className='review_grid_row grid-col-temp grid grid-cols-2 gap-y-2'>
    <div className='review_title'>
      <span>{label}</span>
    </div>
    <div
      className='review_value rich-text-content text-white'
      data-testid='review-html-value'
      dangerouslySetInnerHTML={{__html: value || ''}}
    />
  </div>
);

ReviewHtmlRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string
};

export const ReviewMediaRow = ({label, value}) => (
  <div className='review_grid_row grid-col-rule grid grid-cols-2 gap-y-2'>
    <div className='review_title'>
      <span>{label}</span>
    </div>
    <div className='review_value text-white' data-testid='review-media-value'>
      <span>{replaceExrtaSpaces(value ?? '')}</span>
    </div>
  </div>
);

ReviewMediaRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string
};

export const ReviewRow = ({label, value}) => (
  <div className='review_grid_row grid-col-temp grid grid-cols-2 gap-y-2'>
    <div className='review_title'>
      <span>{label}</span>
    </div>
    <div className='review_value text-white' data-testid='review-value'>
      <span>{replaceExrtaSpaces(value ?? '')}</span>
    </div>
  </div>
);

ReviewRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string
};
